export default {
  "short lang": "ru",
  lang: "Язык",
  "my finances": "Мои финансы",
  errands: "Поручения",
  instruments: "Инструменты",
  reports: "Отчеты",

  "broker account": "Брокерский счет",
  "current balance": "Текущие активы",
  profitability: "Доходность",
  "profitability title": "Доходность",
  "blocked amount": "Заблокированные средства",
  "available funds": "Свободные средства",
  invest: "Инвестировать",
  "deferred companies": "Отложенные компании",
  replenish: "Пополнить",
  Mln: " Млн",
  Bil: " Млрд",
  "amount in ": "Сумма в ",
  overview: "Обзор",
  incomeSinceYearBeginning: "Доходность с начала года",
  portfolio: "Портфель",
  transactions: "Транзакции",
  analysis: "Анализ",
  "during the period": "За период",
  "for today": "За сегодня",
  week: "Неделя",
  month: "Месяц",
  "half year": "Пол года",
  year: "Год",
  quarter: "Квартал",
  "portfolio structure": "Структура портфеля",
  tenge: "Тенге",
  dollars: "Доллары",
  "by country": "По странам",
  "by financial instruments": "По финансовым инструментам",
  "by sector": "По секторам",
  cash: "Денежные средства",
  securities: "Ценные бумаги",
  debts: "Задолженности",
  sale: "Продажа",
  purchase: "Покупка",
  "order book": "Журнал приказов",
  direct: "Прямое",
  opposite: "Обратное",
  "date of application": "Дата подачи",
  description: "Описание",
  quantity: "Количество",
  nominal: "Номинал",
  nominal_value: "Номинальная стоимость",
  price: "Цена",
  sum: "Сумма",
  status: "Статус",

  "set of tools": "Набор инструментов",
  tool: "Инструмент",
  currency: "Валюта",
  "market price": "Рыночная цена с учетом купона",
  favorites: "Избранное",
  buy: "Купить",

  "account reports": "Отчеты по счеты",
  "facial count statement": "Выписка с лицевого счета",
  "report on transactions and operations":
    "Отчет о совершенных сделках и операциях",
  "securities and cash flow statement": "Отчет о движении ЦБ и ДС",
  "securities income payment notice": "Уведомление о выплате дохода по ЦБ",
  download: "Скачать",
  total: "Итого",

  "my assets": "Мои активы",
  title: "Наименование",
  "purchase value": "Покупная стоимость",
  lesion: "Убыток",
  "market cost": "Рыночная стоимость",

  "select date range": "Выберите период",
  "select date": "Выберите дату",
  "select broker": "Выбор брокера",
  "select portfolio": "Выбор портфеля",
  "select client": "Выбор клиента",
  entrance: "Вход",
  "user name": "Логин",
  password: "Пароль",
  login: "Войти",
  "password recovery": "Восстановление пароля",

  "unsubscribe text": "Вы успешно отписались от рассылки",
  "national bank rate": "Курс Нацбанка РК",

  "personal account": "Личный Кабинет",
  contacts: "Контакты",
  back: "< Назад",
  "Dynamic cash assets": "Динамика активов",
  "contact us": "Связаться с нами",
  "back call": "Обратный звонок",
  "call back within 15 minutes": "Перезвоним в течении 15 минут",
  "call me back": "Перезвоните мне",
  "buy security": "Купить ЦБ",
  "add instrument": "Добавить инструмент",
  eds: "ЭЦП",
  "eds login": "Вход по ЭЦП",
  cancel: "Отмена",
  "first name and last name": "Имя и фамилия",
  "serial number": "Серийный номер",
  search: "Найти",
  "Account Statement": "Состояние счёта",
  "Payments Of Incomes": "Уведомления о выплате дохода по ЦБ",
  "Movement of securities and cash": "Отчет о движении ЦБ и ДС",
  "Completed transactions and operations":
    "Отчет о совершенных сделках и операциях",

  "download the app": "Скачайте приложение",
  "for more efficient work, we recommend that you download our mobile application":
    "Для большей эфективности работы рекомендуем вам скачать наше мобильное приложение",

  "asset dynamics": "Динамика активов",
  confirm: "Подтвердить",
  resend: "Отправить повторно",
  resend_text: "Повторно отправить код можно будет через",
  "recovery code is incorrect": "Код восстановления неверен",
  "incorrect user name": "Имя пользователя не верно",
  "repeat password": "Повторите пароль",
  "enter new password": "Введите новый пароль",
  "change password": "Изменить пароль",
  "passwords must match": "Пароли должны совпадать",
  "home page": "Главная страница",
  "password changes successfully": "Пароль был успешно изменен",
  "password changes error": "Во время восстановления пароля произошла ошибка",
  others: "Другие",
  "sec type": "Тип ЦБ",
  "deal type": "Тип сделки",
  "deal date": "Дата сделки",
  rating: "Рейтинги",
  "coupon rate": "Купонная ставка",
  "maturity date": "Дата погашения",
  "income coupon": "Полученный купон",
  dividends: "Дивиденды",
  "buy securities": "Купить ЦБ",
  "sell securities": "Продать ЦБ",
  issuer: "Эмитент",
  "security name": "Наименование",
  ask: "Аск",
  bid: "Бид",
  amount: "Количество",
  "date of expiration": "Дата истечения заявки",
  sell: "Продать",
  validity: "Срок действия",
  "publisher name": "Имя издателя",
  algorithm: "Алгоритм",
  "passwords do not match": "Пароли не совпадают",
  "new password": "Новый пароль",
  "old password": "Старый пароль",
  "repeat new password": "Повтор нового пароля",
  "password change": "Смена пароля",
  save: "Сохранить",
  "required field": "Требуется указать",
  pifs: "ПИФы",
  "holder name": "Наименование банка/брокерской компании",
  "acc type": "Тип счета",
  "bank account": "Номер счета",
  summ: "Сумма",
  "payment purpose": "Тип задолженности",
  "trade code": "Торговый код",
  "debit type": "Вид задолженности",
  number: "Номер",
  comments: "Комментарий",
  annual: "Годовая",
  accumulated: "Накопленная",
  category_sec: "Категория ЦБ",
  "interest charges": "Начисленные проценты",

  //--------------------LKSTASKS-i18n start

  iin: "ИИН",
  "incorrect iin": "Неверный ИИН",
  "last name": "Фамилия",
  "first name": "Имя",
  patronymic: "Отчество",
  "mobile number": "Мобильный номер",
  "email address": "Адрес электронной почты",
  "incorrect form format": "Неверный формат формы",

  "register page": "Страница регистрации",
  "individual account": "Индивидуальный счет",
  "corporate account": "Корпоративный счет",

  "full name": "Полное наименование",
  bin: "БИН",
  "incorrect bin": "Неверный БИН",
  loading: "Загрузка",
  error: "Произошла ошибка",
  "data sent": "Данные отправленны",

  "register info": "Сведения о регистрации",
  "short name": "Сокращенное Наименование",
  "legal form": "Организационно-правовая форма",
  "register document type": "Вид документа, подтверждающего регистрацию",
  "document number": "Номер документа",
  "document issuing date": "Дата выдачи документа",
  "register location": "Место регистрации",
  "internet resource name": "Наименование интернет ресурса (веб-сайт)",
  "choose new file": "Выбрать новый файл",
  "choose file": "Выбрать файл",
  "choose country": "Выберите страну",
  "website link": "Cсылка на веб-сайт",
  "id document number": "Номер документа, удостоверяющего личность",
  "error save": "Произошла ошибка при сохранении",
  "new governing body": "Добавлен новый орган правления",

  "license info": "Сведения о лицензии",
  "buss activity type": "Вид осуществляемой деятельности (ОКЭД)",
  "license number": "Номер лицензии",
  "license issue date": "Дата выдачи лицензии",
  "license validity period": "Срок действия выдачи лицензии",
  "name of the issuing authority": "Наименование органа, выдавшего лицензию",

  "register address": "Адрес регистрации",
  country: "Страна",
  city: "Город",
  street: "Улица",
  address: "Адрес",
  house: "Дом",
  block: "Блок",
  apartment: "Квартира",
  "post index": "Почтовый индекс",
  "address of actual": "Адрес фактического",
  location: "местонахождения",
  residence: "проживания",
  "coincides with register address": "совпадает с адресом регистрации",
  "actual address": "Фактический адрес",
  "register actual address": "Фактический адрес регистрации",

  "taxpayer info": "Cведения о налогоплательщике",
  "taxpayer country": "Страна налогоплательщика",
  "bank details": "Банковские реквизиты (БИК, SWIFT и/или иные реквизиты)",
  lei: "LEI код",
  giin: "GIIN номер",
  "register number": "Регистрационный номер",
  "register number placeholder": "Регистрационный номер (при наличии)",
  "taxpayer number": "Номер налогоплательщика",

  "owner info": "Cведения о учредителях",
  delete: "Удалить",
  "organization form": "Организационная форма",
  share: "Доля",
  from: "от",
  to: "до",
  add: "Добавить",
  info: "Сведения",
  next: "Далее",
  "data saved": "Данные сохранены",
  "location address": "Адрес местонахожденния",
  "fill form": "Заполните форму",
  "cannot be lower '0%' or higher": "Доля не может быть ниже '0%' или выше",

  "management structure": "Структура управления",
  "managing organ name": "Наименование управляющего органа",
  create: "Создать",
  continue: "Продолжить",
  deleted: "Удалено",
  "delete error": "Произошла ошибка при удалении",
  "attach file": "Приложите файл",
  "attach files": "Приложите файлы",

  "client representative info":
    "Сведения о представителях, действующих от имени клиента",
  "client third party info":
    "Сведения о третьем лице, в интересах которого действует клиент",
  "empty list": "Пустой список",

  "branch/representative additional info":
    "Дополнительные сведения о филиале/представительстве",
  change: "Изменить",
  "branch name": "Наименование филиала",
  "bin (if available)": "БИН (при наличии)",
  "document type register confirm": "Вид документа, подтверждающий регистрацию",
  "body register name": "Наименование регистрирующего органа",
  "register date (re-register)": "Дата регистрации (перерегистрации)",
  "registered address of the branch (representative office)":
    "Зарегистрированный адрес филиала (представительства)",

  "financing sources info": "Сведения об источниках финансирования",
  "income sources list": "Список источников дохода",
  "bank account list": "Список банковских счетов",
  "choose bank": "Выберите банк",
  "bank name": "Наименование банка",
  "account number": "Номер счета",
  "total annual income": "Размер общего годового дохода",
  "characteristics of financial condition":
    "Характеристика финансового состояния",
  "your income source": "Ваш источник дохода",
  "financial condition total cost":
    "Совокупная стоимость финансового состояния",
  "liabilities total value":
    "Совокупная стоимость обязательств (банковские кредиты, ипотека,лизинг и др.)",
  "countries main operating assets":
    "Страна или страны, в которых находятся основные операционные активы",
  "changes saved": "Изменения сохранены",
  "empty field": "Пустое поле",
  adding: "Добавление",
  "fill fields": "Заполните все поля",
  "not chosen": "Не выбран",
  "repeatedly through": "повторно через",
  "(le real estate, values, capital share)":
    "(недвижимое имущество, ценности, доля в капитале/процент акций юридического лица)",
  other: "Другое",

  "services provision procedure":
    "Порядок оказания брокерских услуг и услуг номинального держания",
  contract: "Договор",
  link: "Ссылка",
  tariffs: "Тарифы",
  "user manual": "Руководство пользователя",
  "send sms code": "Отправить смс код",
  "verification code": "Код верификации",
  "check code": "Проверить код",
  "sms confirm sent":
    "На указанный Вами номер телефона будет отправлено SMS с кодом подтверждения",
  "input code": "Введите код",
  "confirmation code accepted": "Код подтверждения принят",
  "confirmation code not accepted": "Ошибка: Код подтверждения не принят",
  wait: "Подождите",
  "confirmation code sent to number":
    "Код подтверждения был отправлен на номер",
  "confirmation code not sent": "Ошибка: Нe удалось отправить код",
  "accept contract condition": "Просим ознакомиться и принять условия договора",
  "number changed": "Номер изменён",
  "number not saved": "Ошибка: Не удалось сохранить номер",
  "register end": "Завершение регистрации",
  "go back correct":
    "Вы можете вернуться и исправить данные или завершить регистрацию",
  "complete registration": "Завершить регистрацию",
  "application accepted": "Ваша заявка на открытие счета успешно принята!",
  "check data/ prepare docs":
    "Мы проверим Ваши персональные данные и подготовим необходимые документы для подписания",
  "application status track":
    "Вы самостоятельно можете отслеживать статус обработки Заявки.",
  "questions by phone": "По всем вопросам Вы можете обратиться по телефону",
  "contact phone / email": "+7 727 344 29 00 или написать на электронный адрес",
  "registration completed": "Регистрация завершена",
  "already uploaded": "Ваш файл уже загружен",
  "maximum size 5mb": "Максимальный размер файла 5 Мб",

  identification: "Идентификация",
  citizenship: "Гражданство",
  birthday: "Дата рождения",
  "birth place": "Место рождения",
  "document type": "Тип документа",
  series: "Серия",
  "issue date": "Дата выдачи",
  expires: "Действителен до",
  "issued by": "Кем выдано",
  "visa migration card": "Виза/Миграционная карта",
  "visa number": "Номер визы",
  "document expires": "Документ годен до",
  "migration card number": "Номер миграционной карты",

  "job info": "Сведения о работе",
  "tax residency": "Налоговое Резиденство",
  "work place position": "Место работы и должность",
  "entrepreneurial/license activity":
    "Занимаетесь ли Вы предпринимательской и/или лицензируемой деятельностью?",
  "document photo front":
    "Фотография документа, удостоверяющего личность - Лицевая сторона",
  "document photo back":
    "Фотография документа, удостоверяющего личность - Задняя сторона",
  "passport driving license internal passport":
    "Загранпаспорт, Водительское удостоверение, Общегражданский внутренний паспорт",
  "send files": "Отправить файлы",
  "document uploaded": "Документ загружен",
  "file upload error": "Ошибка: Не удалось загрузить файлы",
  // --------------------------------------documents
  "charter le / Regulation branch or representative office":
    "Устав юридического лица / Положение о филиале или представительстве (копия, заверенная уполномоченным лицом и оттиском печати (при наличии) юридического лица)",
  "state register certificate":
    "Справка о государственной регистрации (перерегистрации) юридического лица, филиала/представительства (копия, заверенная уполномоченным лицом и оттиском печати (при наличии) юридического лица либо заверенная нотариусом)",
  "le activity license":
    "Лицензия (в случае если деятельность юридического лица лицензируется) (копия, заверенная уполномоченным лицом и оттиском печати (при наличии) юридического лица либо заверенная нотариусом)",
  "holders register extract":
    "Выписка из реестра держателей ценных бумаг для резидентов РК (оригинал либо копия, заверенная уполномоченным лицом и оттиском печати (при наличии) юридического лица либо заверенная нотариусом)",
  "signatures notarized document":
    "Нотариально засвидетельствованный документ с образцами подписей (оригинал)",
  "non-residents register certificate":
    "Регистрационный сертификат из страны регистрации для нерезидентов РК (выписка из Торгового реестра или эквивалент) (оригинал либо копия, заверенная уполномоченным лицом и оттиском печати (при наличии) юридического лица либо заверенная нотариусом)",
  "executive body id":
    "Документы, удостоверяющие личность руководителя и членов исполнительного органа юридического лица, руководителя филиала/представительства (копия, заверенная уполномоченным лицом и оттиском печати (при наличии) юридического лица либо заверенная нотариусом)",
  "beneficial le id":
    "Документы, удостоверяющие личность бенефициарных собственников юридического лица (копия)",
  "consolidated financial statements":
    "Консолидированная финансовая отчетность за три последних года, в том числе за последний год с заключением аудитора (копия, направленная в электронном виде)",
  "FATCA tax form (original)": "Налоговую форму FATCA (оригинал)",
  "agreement terms confirm":
    'Настоящим подтверждаю, что ознакомлен и принимаю условия Договора оказания брокерских услуг и услуг номинального держания и тарифы на услуги АО "First Heartland Securities"',
  "le body proxy / decision":
    "Доверенность или решение уполномоченного органа юридического лица, выданное в отношении представителя юридического лица, либо руководителя филиала или представительства, который будет заключать брокерский договор и осуществлять иные действия (оригинал)",
  "le representative / head/ office id":
    "Документ, удостоверяющий личность представителя юридического лица, руководителя филиала/представительства (копия, заверенная уполномоченным лицом и оттиском печати (при наличии) юридического лица либо заверенная нотариусом)",
  "Another session started": "Выполнен вход с другого устройства",
  "Active token not found": "Время вашей сессии истекло"
};
